import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ProcessLite} from "../../../classes/process-lite";
import {ProcessType} from "../../../classes/process-type";
import {GUID} from "../../../classes/utilities/guid";

@Component({
  selector: 'app-process-config',
  templateUrl: './process-config.component.html',
  styleUrls: ['./process-config.component.css']
})
export class ProcessConfigComponent implements OnInit {

  @ViewChild('inputProcessName', { static: true }) inputProcessNameElementRef: ElementRef;

  processForm: FormGroup;

  title = 'Create New Step';
  processTypes: ProcessType[];

  constructor(
      public dialogRef: MatDialogRef<ProcessConfigComponent>,
      @Inject(MAT_DIALOG_DATA) public data: ProcessLite,
      private formBuilder: FormBuilder) {}

  ngOnInit(): void {

    // console.log('ngOnInit.data:');
    // console.dir(this.data);

    this.processForm = new FormGroup({
      key: new FormControl('', []),
      name: new FormControl('', [Validators.required]),
      description: new FormControl('', [Validators.required]),
      processType: new FormControl('', [Validators.required]),
      model: new FormControl('', []),
      propertySets: this.formBuilder.array([
        this.initPropertySet(GUID.newGuid(), '', undefined)]
      ),
      publicOutputInd: new FormControl('', []),
      outputName: new FormControl('', []),
      level: new FormControl('0', []),
    });

    // this.processForm = new FormGroup({
    //   key: new FormControl('', []),
    //   name: new FormControl('', [Validators.required]),
    //   description: new FormControl('', [Validators.required]),
    //   processType: new FormControl('', [Validators.required]),
    //   model: new FormControl('', []),
    //   // properties: this.formBuilder.array([this.createProcessProperty()]),
    //   propertySets: this.formBuilder.array([this.initProcessPropertySet()]),
    //   publicOutputInd: new FormControl('', []),
    //   outputName: new FormControl('', []),
    //   level: new FormControl('0', []),
    // });


    if (this.data && this.data instanceof ProcessLite) {

      let processLite: ProcessLite;
      processLite = this.data as ProcessLite;
      this.processTypes = processLite.processTypes;

      this.title = 'Edit Step';

      console.log('ngOnInit.processLite:');
      console.dir(processLite);

      this.processForm.patchValue(processLite);
      const control = <FormArray>this.processForm.controls['propertySets'];
      control.clear();
      // if (processLite.propertySets && processLite.propertySets.length > 0) {
      //   control.patchValue(processLite.propertySets)
      // }
      if (processLite.propertySets && processLite.propertySets.length > 0) {
        processLite.propertySets.forEach(propertySet => {
          if (propertySet && propertySet.properties && propertySet.properties.length > 0) {
            let propertySetProperties = this.formBuilder.array([])
            propertySet.properties.forEach(property => {
              propertySetProperties.push(
                  this.initProperty(property.name, property.value));
            });
            control.push(this.initPropertySet(propertySet.key, propertySet.name, propertySetProperties));
          }
        });
      }
    }

    const publicOutputIndControl = this.processForm.get('publicOutputInd');
    const outputNameControl = this.processForm.get('outputName');

    publicOutputIndControl.valueChanges
        .subscribe(publicOutputInd => {
              console.log('publicOutputInd changed!');
              console.dir(publicOutputInd);

          if (publicOutputInd) {
            outputNameControl.setValidators([Validators.required]);
            outputNameControl.updateValueAndValidity();
          } else {
            outputNameControl.setValidators(null);
            outputNameControl.updateValueAndValidity();
          }
        });
  }


  close() {
    console.log('close');
    this.dialogRef.close();
  }

  save() {
    console.log('save');
    console.dir(this.processForm.value);
    this.dialogRef.close(this.processForm.value);
  }

  compareProcessTypes(o1: any, o2: any) {
    if(o1.id == o2.id)
      return true;
    else return false
  }

  initPropertySet(key: string, name: string, properties: FormArray) {
    if (properties) {
      return this.formBuilder.group({
        'key': [key ? key : GUID.newGuid()],
        'name': [name, []],
        'properties': properties
      });
    } else {
      return this.formBuilder.group({
        'key': [key ? key : GUID.newGuid()],
        'name': [name, []],
        'properties': this.formBuilder.array([
          this.initProperty('', '')
        ])
      });
    }
  }

  initProperty(name: string, value: string) {
    return this.formBuilder.group({
      'name': [name, []],
      'value': [value, []],
    });
  }

  addPropertySet() {
    const control = <FormArray>this.processForm.controls['propertySets'];
    control.push(this.initPropertySet(GUID.newGuid(), '', undefined));
  }

  deletePropertySet(propertySetsIndex: number) {
    const control = <FormArray>this.processForm.controls['propertySets'];
    control.removeAt(propertySetsIndex);
  }

  addProcessProperty(propertySetsIndex: number) {
    const control = (<FormArray>this.processForm.controls['propertySets']).at(propertySetsIndex).get('properties') as FormArray;
    control.push(this.initProperty('', ''));
  }

  deleteProcessProperty(propertySetsIndex: number, propertyIndex: number) {
    const control = (<FormArray>this.processForm.controls['propertySets']).at(propertySetsIndex).get('properties') as FormArray;
    control.removeAt(propertyIndex);
  }
}
